/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 */

import gql from "graphql-tag";

export const REGISTER_FISERV_PAYMENT = gql`
  mutation RegisterFiservPayment($data: FiservPayInput!) {
    registerFiservPayment(data: $data)
  }
`;
